"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGScatterPlotChart = void 0;
const react_1 = __importStar(require("react"));
const scatterplot_1 = require("@nivo/scatterplot");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const configContext_1 = require("../../../contexts/configContext");
const TGScatterPlotChart = (props) => {
    const { defaultDateTimeFormat } = configContext_1.useConfig();
    const { dateFormat, dateTimeFormat } = react_1.useMemo(() => ({
        dateFormat: gen5_shared_utilities_1.getDateFormat(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, { datePartOnly: true, tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
        dateTimeFormat: gen5_shared_utilities_1.getDateTimeFormat(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.timeFormat, { tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
    }), [defaultDateTimeFormat]);
    const { isXAxisDate, isYAxisDate } = react_1.useMemo(() => props.data.reduce((acc, serie) => ({
        isXAxisDate: acc.isXAxisDate || serie.data.some(d => lodash_1.isDate(d.x)),
        isYAxisDate: acc.isYAxisDate || serie.data.some(d => lodash_1.isDate(d.y)),
    }), { isXAxisDate: false, isYAxisDate: false }), [props.data]);
    const formatDateValue = (value) => {
        const local = moment_1.default(value);
        return local.millisecond() === 0 ? moment_1.default.utc(value).format(dateFormat) : local.format(dateTimeFormat);
    };
    return react_1.default.createElement(scatterplot_1.ResponsiveScatterPlot, Object.assign({}, props, { margin: { top: 60, right: 140, bottom: 70, left: 90 }, xScale: {
            type: isXAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, xFormat: isXAxisDate ? formatDateValue : ">-.2f", yScale: {
            type: isYAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, yFormat: isYAxisDate ? formatDateValue : ">-.2f", blendMode: "multiply", axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
            format: isXAxisDate ? formatDateValue : undefined,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
            format: isYAxisDate ? formatDateValue : undefined,
        }, legends: [
            {
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 130,
                translateY: 0,
                itemWidth: 100,
                itemHeight: 12,
                itemsSpacing: 5,
                itemDirection: 'left-to-right',
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ] }));
};
exports.TGScatterPlotChart = TGScatterPlotChart;
exports.default = exports.TGScatterPlotChart;
//# sourceMappingURL=TGScatterPlotChart.js.map